import {createContext} from "react";
import {Accelerator} from "../interfaces/accelerator";

interface AcceleratorContextType {
    loaded: boolean,
    accelerators: Accelerator[],
    averageScore: number,
    setAverageScore: (value: number) => void,
    setAccelerators: ((value: (((prevState: Accelerator[]) => Accelerator[]) | Accelerator[])) => void)
}

export const AcceleratorContext = createContext<AcceleratorContextType>({
    loaded: false,
    accelerators: [],
    averageScore: 0,
    setAverageScore: () => {
    },
    setAccelerators: () => {
    }
});